import React from 'react';

const SuccessPage = () => {
  return (
    <div className="main-content">
      <div className="container">
        <div className="success-content">
          <h2>Thank you</h2>
          <p>Thank you. Your China Readiness Check has been submitted successfully.</p>
          <p>We appreciate you taking the time to complete the China Readiness Check.</p>
          <p>Our team will review your responses and may contact you regarding relevant services and support opportunities.</p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;